import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConnectionAlertComponent } from './connection-alert.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ConnectionAlertComponent],
  exports: [ConnectionAlertComponent],
})
export class ConnectionAlertModule {}
